import React from 'react';
import DragDropZone from '../DragDropZone/DragDropZone';

export default function RegistrationCard(props) {
	// console.log('RegistrationCard', props);
	return (
		<div className="RegistrationCard">
			<div className="card">
				<div className="card-body p-5">
					<h2 className="w-50 mb-5">
						{I18n.t('admin.registration_card_title')}
					</h2>
					<label htmlFor="">Email Address</label>
					<input
						className="w-100 p-2"
						type="text"
						placeholder="name@example.com"
					/>
					<p className="sub-title">Set your Password</p>
					<label htmlFor="">Password</label>
					<input className="w-100 p-2" type="text" placeholder="Password" />
					<label htmlFor="">Confirm Password</label>
					<input
						className="w-100 p-2"
						type="text"
						placeholder="Confirm password"
					/>
					<DragDropZone />
					<button type="button" className="btn btn-primary w-100">
						{I18n.t('admin.registration_card_cta')}
					</button>
				</div>
			</div>
		</div>
	);
}
